module.exports = __webpack_public_path__ + "img/Cliente.5fffa95b.png";